import $ from "jquery";


export function bindNavEvents(){
    $("body").on('click', '.js-menu-btn', function () {
        $('body').toggleClass('menu-active');

        return false;
    });

    $(window).on("scroll", () => {
        let scrollTop = $(window).scrollTop() + 20;
        let target = $(".js-scroll-target:first").attr("id");

        $($(".js-scroll-target").get().reverse()).each(function (_, el) {
            let $el = $(el);

            if (scrollTop >= $el.offset().top) {
                target = $el.attr("id");
                return false;
            }
        });

        $(".js-nav-link.nav__link").removeClass("nav__link--active").filter("[href='#" + target + "']").addClass("nav__link--active");
    });
}


